const FilterOptionsConstants = {
    OPTION_VALUE: 0,
    OPTION_LABEL: 1,
    
    /* Actions */
    UPDATE_FILTER_OPTIONS_ACTION: 'UPDATE_FILTER_OPTIONS_ACTION',
    LOAD_FILTER_OPTIONS_ACTION: 'LOAD_FILTER_OPTIONS_ACTION',

    LOAD_TYRE_FILTER_OPTIONS_ACTION: 'LOAD_TYRE_FILTER_OPTIONS_ACTION',
    LOAD_TYRE_MOTO_FILTER_OPTIONS_ACTION: 'LOAD_TYRE_MOTO_FILTER_OPTIONS_ACTION',
};

export default FilterOptionsConstants;